<nav class="nav nav-transparent">
    <main class="container-lg container-fluid d-flex-center-center px-xl-5 px-lg-4 px-md-5 px-3">
        <section class="row w-100">
            <article class="col-lg-5 col-10 pl-0">
                <!-- <a class="navbar-brand d-flex align-items-center" href="#" *ngIf="(partnerSubject$ | async) as partner"> -->
                <a class="navbar-brand d-flex align-items-center" routerLink="/">
                    <img class="navbar-brand__logo no-background-color d-flex-center-center mr-3"
                        *ngIf="(partnerSubject$ | async)?.logoUrl" [src]="(partnerSubject$ | async)?.logoUrl">
                    <span class="navbar-brand__logo navbar-brand__no-logo  d-flex-center-center mr-3"
                        *ngIf="!(partnerSubject$ | async)?.logoUrl">{{ (partnerSubject$ | async)?.name!?.charAt(0) }}</span>
                    <span class="navbar-brand__name ellipsis">{{ (partnerSubject$ | async)?.name }}</span>
                </a>
            </article>
            <!-- navbar-menu desktop -->
            <article class="nav-menu col-lg-7 p-0 d-lg-block d-none m-auto">
                <ul class="nav-menu__options pl-xl-5 pl-0" *ngIf="isBrowser">
                    <li class="mr-3">
                        <!-- Be a Member button -->
                        <fitscovery-membership-button></fitscovery-membership-button>
                    </li>
                    <li>
                        <!-- Vendor Features -->
                        <button mat-button [matMenuTriggerFor]="vendorFeaturesMenu"
                            class="menu-button explore-button mr-3">{{ 'toolbars.exploreMenuText' | translate }}
                            <mat-icon>arrow_drop_down</mat-icon></button>
                        <mat-menu #vendorFeaturesMenu="matMenu">
                            <button mat-menu-item routerLink="/events">
                                <span>{{ 'toolbars.liveEventsMenuOption' | translate }}</span>
                                <i class="far fa-calendar-check"></i>
                            </button>
                            <button mat-menu-item routerLink="/workouts">
                                <span>{{ 'toolbars.onDemandMenuOption' | translate }}</span>
                                <i class="fas fa-dumbbell"></i>
                            </button>
                            <button mat-menu-item routerLink="/community">
                                <span>{{ 'toolbars.communityMenuOption' | translate }}</span>
                                <i class="fas fa-users"></i>
                            </button>
                            <!-- <button mat-menu-item>
                                <span>Resource Hub</span>
                                <i class="fas fa-universal-access"></i>
                            </button>
                            <button mat-menu-item>
                                <span>Book a Session</span>
                                <i class="fas fa-ticket-alt"></i>
                            </button> -->
                        </mat-menu>
                    </li>
                    <li *ngIf="(userState$ | async) as user">
                        <!-- User Menu  -->
                        <ng-container *ngIf="isSigningOut">
                          <button class="btn btn-login menu-button" [ngStyle]="{ 'margin-right': '24px' }">
                            <mat-spinner [diameter]="17" class="mx-auto"></mat-spinner>
                          </button>
                        </ng-container>
                        <ng-container *ngIf="!isSigningOut">
                          <button id="user-button" mat-button [matMenuTriggerFor]="userMenu" class="menu-button"><img
                                  src="https://d3uee0gs4p7cty.cloudfront.net/default-images/user/user-icon.svg"
                                  alt="user icon" class="pr-1">
                                  <span id="user-displayname"> {{user.displayName}} </span>
                              <mat-icon>arrow_drop_down</mat-icon>
                          </button>
                        </ng-container>
                        <mat-menu #userMenu="matMenu">
                            <a [href]="accountUrl" target="_blank" mat-menu-item>
                                <span>{{ 'toolbars.userAccountMenuOption' | translate }}</span>
                                <i class="fas fa-user-alt"></i>
                            </a>
                            <a [href]="myDiscoveryUrl" target="_blank" mat-menu-item>
                                <span>{{ 'toolbars.fitnessTrackerMenuOption' | translate }}</span>
                                <i class="fas fa-book"></i>
                            </a>
                            <!-- <button mat-menu-item>
                                <span>Cart</span>
                                <i><img src="https://d3uee0gs4p7cty.cloudfront.net/icons/cart-black-icon.svg" alt="cart icon"></i>
                            </button> -->
                            <hr class="mt-2 mb-1">
                            <button mat-menu-item (click)="logout()">
                                <span>{{ 'toolbars.logoutMenuOption' | translate }}</span>

                                <i class="fas fa-power-off"></i>
                            </button>
                        </mat-menu>
                    </li>
                    <li class="pr-4" *ngIf="(userState$ | async) === null">
                        <!-- Login button  -->
                        <button class="btn btn-login"
                            (click)="login()">
                            <ng-container *ngIf="isSigningOut">
                              <mat-spinner [diameter]="17" class="mx-auto"></mat-spinner>
                            </ng-container>
                            <ng-container *ngIf="!isSigningOut">
                              {{ 'toolbars.loginButtonText' | translate }}
                            </ng-container>
                          </button>
                    </li>
                    <li class="mr-3">
                        <button id="user-button" mat-button [matMenuTriggerFor]="userMenu" class="menu-button">
                            <mat-icon>language</mat-icon>
                            <span> {{ (language$ | async) | uppercase }} </span>
                        </button>
                    </li>
                    <li>
                        <a class="fitscovery-logo" href="https://fitscovery.com" target="_blank">
                            <img alt="fitscovery logo" class="nav-logo nav-logo--white"
                                src="https://d3uee0gs4p7cty.cloudfront.net/default-images/logo/logo-pink-white-text.svg">
                            <img alt="fitscovery logo" class="nav-logo nav-logo--black"
                                src="https://d3uee0gs4p7cty.cloudfront.net/default-images/logo/logo-pink-black-text.svg">
                        </a>
                    </li>
                </ul>

                <ul class="nav-menu__options pl-xl-5 pl-0" *ngIf="isServer || !isBrowser">

                  <li fxLayout="row" fxLayoutAlign="center center">
                    <ngx-skeleton-loader
                      [theme]="{ 
                        'border-radius': '8px',
                        width: '113.41px',
                        height: '36px',
                        margin: 'auto 16px auto 0',
                        background: 'rgba(#edeef2, 0.1)'
                      }">
                    </ngx-skeleton-loader>
                  </li>

                  <li fxLayout="row" fxLayoutAlign="center center">
                    <ngx-skeleton-loader
                      [theme]="{ 
                        'border-radius': '8px',
                        width: '115.03px',
                        height: '30px',
                        margin: 'auto 16px auto 0',
                        background: 'rgba(#edeef2, 0.1)'
                      }">
                    </ngx-skeleton-loader>
                  </li>
                  
                  <li fxLayout="row" fxLayoutAlign="center center">
                    <ngx-skeleton-loader
                      [theme]="{ 
                        'border-radius': '8px',
                        width: '67.23px',
                        height: '37.16px',
                        margin: 'auto 24px auto 0',
                        background: 'rgba(#edeef2, 0.1)'
                      }">
                    </ngx-skeleton-loader>
                  </li>
                  
                  <li fxLayout="row" fxLayoutAlign="center center">
                    <ngx-skeleton-loader
                      [theme]="{ 
                        'border-radius': '8px',
                        width: '44.74px',
                        height: '36.37px',
                        margin: 'auto 32px auto 0',
                        background: 'rgba(#edeef2, 0.1)'
                      }">
                    </ngx-skeleton-loader>
                  </li>
                  
                  <li fxLayout="row" fxLayoutAlign="center center">
                    <ngx-skeleton-loader
                      [theme]="{ 
                        'border-radius': '8px',
                        width: '75.69px',
                        height: '13.49x',
                        margin: 'auto 0',
                        background: 'rgba(#edeef2, 0.1)'
                      }">
                    </ngx-skeleton-loader>
                  </li>

                </ul>

            </article>
            <!-- navbar-menu mobile -->
            <article class="nav-menu col-2 d-lg-none d-flex">
                <button id="user-button" mat-button [matMenuTriggerFor]="userMenu" class="menu-button mobile mr-3">
                    <mat-icon>language</mat-icon>
                    <span> {{ (language$ | async) | uppercase }} </span>
                </button>
                <a class="icon-hamburger"><img src="https://d3uee0gs4p7cty.cloudfront.net/icons/menu-bars-icon.svg"
                        alt="menu bars icon" (click)="isMobileNavOpen = true"></a>
            </article>
        </section>
    </main>
</nav>
<!-- mobile nav -->
<fitscovery-ui-mobile-nav *ngIf="isMobileNavOpen" class="d-lg-none d-block" (closeNav)="isMobileNavOpen = false"
    (logoutClicked)="logout()" (loginClicked)="login()"></fitscovery-ui-mobile-nav>

<mat-menu #userMenu="matMenu">
    <button mat-menu-item (click)="changeLanguage('en')">{{ 'global.english' | translate}}</button>
    <button mat-menu-item (click)="changeLanguage('kr')">{{ 'global.korean' | translate}}</button>
</mat-menu>